module.exports = __webpack_public_path__ + "static/img/bg_dark.d42b813f.png";